/**
 * @license Copyright 2019 Google Inc. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except in compliance with the License. You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software distributed under the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions and limitations under the License.
 */

.project-list {
  --project-list-height: calc(100vh - var(--page-header-height));
  --project-list-width: 100vw;

  position: absolute;
  top: var(--page-header-height);
  left: 0;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  height: var(--project-list-height);
  width: var(--project-list-width);

  text-align: center;
}

.project-list .paper {
  max-width: 50vw;
  max-height: 100%;
  padding: calc(var(--paper-padding) * 2);
  z-index: 2;
  overflow: auto;
}

.project-list img {
  height: 80px;
  width: 80px;
  margin-bottom: var(--base-spacing);
}

.project-list ul {
  list-style: none;
  padding: 0;
}

.project-list li {
  font-size: var(--header-font-size);
  padding: var(--base-spacing);
}

.project-list li a {
  color: var(--base-text-color);
  text-decoration: none;
}

.project-list li a:hover {
  color: var(--compare-color);
}

.project-list__confetti-background {
  position: absolute;
  top: 0;
  left: 0;
  height: var(--project-list-height);
  width: var(--project-list-width);
  z-index: 1;
}

.project-list__confetti-background img {
  margin: 0;
  height: var(--project-list-height);
  width: var(--project-list-width);
  object-fit: cover;
}

.no-projects h2 {
  font-size: var(--title-font-size);
  line-height: calc(var(--title-font-size) * 2);
}

.no-projects pre {
  display: inline;
  background: var(--secondary-background-color);
  color: var(--compare-color);
  padding: calc(var(--base-spacing) / 2);
  border-radius: calc(var(--base-spacing) / 4);
}
